import { get } from 'lodash'

export const getPagePermissions = (user, stockKey, pageKey) => {
    const pageRole = get(user, ['roles', stockKey, pageKey], {})
    return pageRole
}